import React from "react";
import modalpoints from "../../assets/modalpoints.png";
import { ModalContainer, ModalContent, ModalImageContainer, Image } from "./styles";
const ModalPoints = (props) => {
  return (
    <ModalContainer onClick={props.onClose}>
      <ModalContent>
          <ModalImageContainer>
            <Image onClick={props.onClose} src={modalpoints} alt="Placeholder" />
          </ModalImageContainer>
      </ModalContent>
    </ModalContainer>
  );
};

export default ModalPoints;

